import { useEffect, useState } from 'react';
import { ORIGIN_IDENTIFIERS } from 'src/common/constants';
import { getEnvironmentAppropriateFullDashboardURL } from 'src/utils/getters/getEnvironmentAppropriateFullDashboardURL';
import { isCurrentRuntimeEnvironmentRedirectExempt } from 'src/utils/getters/isCurrentRuntimeEnvironmentRedirectExempt';
import { CUSTOM_ACTIONS } from 'src/services/datadog/constants';
import { noop } from 'src/utils/noop';
import { getFinalDestinationForLoginDashboard } from '../../utils/getters/getFinalDestinationForLoginDashboard';

export const useMigrateToZillowState = () => {
    const [isRedirectDecisionMade, setIsRedirectDecisionMade] = useState(false);
    useEffect(() => {
        if (
            window.location.hostname.includes(ORIGIN_IDENTIFIERS.ZILLOW) ||
            isCurrentRuntimeEnvironmentRedirectExempt()
        ) {
            setIsRedirectDecisionMade(true);
            return;
        }
        const redirectToZillow = async () => {
            const { datadog } = await import(
                /* webpackChunkName: "datadog" */
                'src/services/datadog'
            ).catch(
                /**
                 * Ignored from coverage because trying to mock Jest to throw an error on import has proven challenging
                 */
                /* istanbul ignore next */
                () => ({
                    datadog: {
                        addAction: noop,
                    },
                })
            );
            const [, relativePath] = window.location.href.split(window.location.hostname);
            const sanitizedRelativePath = getFinalDestinationForLoginDashboard(relativePath);

            const zillowEquivalentPath = getEnvironmentAppropriateFullDashboardURL(sanitizedRelativePath);
            datadog.addAction(CUSTOM_ACTIONS.MIGRATION_REDIRECT, {
                from: relativePath,
                to: zillowEquivalentPath,
            });
            window.location.replace(zillowEquivalentPath);
        };
        redirectToZillow();
    }, []);

    return {
        isRedirectDecisionMade,
    };
};
